import { formatCedis, missionReward } from '@accra/shared';
import type { RunStats } from '../../game/RunState';
import { missionText, progressOf, type MissionBoard } from '../../meta/missions';
import { el } from '../components/el';

/** "Missions · Level 2 · 1/3 done" with a progress bar per mission and the reward for each. */
export class MissionsPanel {
  readonly root = el('div', 'missions');

  render(board: MissionBoard, stats: RunStats | null, walletPesewas: number | null = null): void {
    const done = board.missions.filter((m) => m.done || (stats && progressOf(m, stats) >= m.target)).length;
    const head = el('div', 'missions-head');
    head.append(el('h3', '', 'Missions'), el('span', '', `Level ${board.level} · ${done}/3 done`));
    const list = el('ul', 'missions-list');
    const reward = formatCedis(missionReward(board.level));
    for (const mission of board.missions) {
      const progress = Math.min(mission.target, progressOf(mission, stats));
      const shown = mission.id === 'earn' ? `${formatCedis(progress)} / ${formatCedis(mission.target)}` : `${progress.toLocaleString()}/${mission.target.toLocaleString()}`;
      const item = el('li', mission.done || progress >= mission.target ? 'done' : '');
      const top = el('div', 'mission-top');
      top.append(el('span', 'mission-text', missionText(mission)), el('span', 'mission-count', `${shown} · ${reward}`));
      const bar = el('div', 'mission-bar');
      const fill = el('div', 'mission-fill');
      fill.style.width = `${(progress / mission.target) * 100}%`;
      bar.append(fill);
      item.append(top, bar);
      list.append(item);
    }
    this.root.replaceChildren(head, list);
    if (walletPesewas !== null) {
      const wallet = el('div', `missions-wallet ${walletPesewas < 0 ? 'debt' : ''}`, walletPesewas < 0 ? `You owe ${formatCedis(-walletPesewas)}` : `${formatCedis(walletPesewas)} in your wallet`);
      this.root.append(wallet);
    }
  }
}
